import { render, staticRenderFns } from "./WardIdle.vue?vue&type=template&id=23459b1c&scoped=true"
import script from "./WardIdle.vue?vue&type=script&lang=js"
export * from "./WardIdle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23459b1c",
  null
  
)

export default component.exports